module.exports = __webpack_public_path__ + "static/img/shop1.4756847.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop1.png
// module id = rAIa
// module chunks = 2